import React from "react";
import WidgetContainer from "../WidgetContainer.jsx";
import pandaImg from "../../../../../assets/panda_stakeholders.png";
import StakeholderVisibilityMap from "./StakeholderVisibilityMap.jsx";
import StakeholderRelationshipRadar from "./StakeholderRelationshipRadar.jsx";
import StakeholderPrioritySummary from "./StakeholderPrioritySummary.jsx";

const StakeholderMapContainer = ({
  userId,
  subsectionId,
  onComplete,
  onPhaseChange,
}) => {
  return (
    <WidgetContainer
      userId={userId}
      subsectionId={subsectionId}
      onComplete={onComplete}
      onPhaseChange={onPhaseChange}
      intro={{
        image: pandaImg,
        title: "Mapping Stakeholders",
        description:
          "Let’s map the key people who influence your work and growth. A stakeholder map helps you see who supports your goals, who you need to engage with, and where stronger connections can help you move forward.",
        buttonLabel: "Start Mapping",
      }}
      steps={[
        {
          id: "builder",
          component: StakeholderVisibilityMap,
        },
        {
          id: "radar",
          title: "Stakeholder Relationship Radar",
          component: StakeholderRelationshipRadar,
            fullScreen: true,
          
        },
        {
          id: "summary",
          title: "Stakeholder Summary",
          component: StakeholderPrioritySummary,
                    fullScreen: true, // 🔥 this step takes over full screen
        },
      ]}
    />
  );
};

export default StakeholderMapContainer;
